<template>
  <div v-bind:class="contentClass">
    <vue-title :title="$t('identityProvider:securityQuestions:title')"></vue-title>
    <h1 class="section-title">{{ $t('identityProvider:securityQuestions:title') }}</h1>

    <div v-if="model.showError">
      <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-generic">
        <span class="alert-icon">&#9888;</span>
        <span>{{ model.errorMessage }}</span>
      </div>
      <button type="button" v-on:click="loginCancel" name="Action:RedirectToLogin" class="button" :disabled="disabled">{{ $t('shared:action:back') }}</button>
    </div>
    <div v-else>
      <form ref="form" action="authentication/setupquestions" @submit.prevent="validateBeforeSubmit" autocomplete="off">
        <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" v-show="errors.any()" data-test-element="security-questions-warning">
          <span class="alert-icon">&#9888;</span>
          <span v-if="errors.has('.')">{{ errors.first('.') }}</span>
          <span v-else>{{ $t('validation:summary') }}</span>
        </div>
        <fieldset>
          <div class="panel-message">
            {{ model.instructions }}
          </div>
          <div v-for="(question,i) in model.questions">
            <div class="form-group">
              <label class="label" :data-test-element="'security-question-label-' + (i + 1)">{{ $t('identityProvider:securityQuestions:question') }} {{ i+1 }}</label>
              <select v-if="model.availableQuestions.length>1" class="security-question control security-answer-padding" :name="'question'+i" v-model="model.questions[i].id" v-validate="'required', 'not_in:null'" :data-vv-as="$t('identityProvider:securityQuestions:question') + ' ' + (i + 1)" v-bind:class="{ 'input-validation-error': hasErrorOn('question'+i) }" @change="changeQuestion" :data-test-element="'security-question-' + (i + 1)">
                <option value=null>{{ $t('identityProvider:securityQuestions:defaultOption') }}</option>
                <option v-for="availableQuestion in model.availableQuestions[i]" v-bind:value="availableQuestion.id">
                  {{ availableQuestion.text }}
                </option>
              </select>
              <select v-else-if="model.availableQuestions.length ==1" class="security-question control security-answer-padding" :name="'question'+i" v-model="model.questions[i].id" v-validate="'required', 'not_in:null'" :data-vv-as="$t('identityProvider:securityQuestions:question') + ' ' + (i + 1)" v-bind:class="{ 'input-validation-error': hasErrorOn('question'+i) }" @change="changeQuestion" :data-test-element="'security-question-' + (i + 1)">
                <option value=null>{{ $t('identityProvider:securityQuestions:defaultOption') }}</option>
                <option v-for="availableQuestion in model.availableQuestions[0]" v-bind:value="availableQuestion.id">
                  {{ availableQuestion.text }}
                </option>
              </select>
              <span class="field-validation-error" v-show="hasErrorOn('question'+i)" :data-test-element="'security-question-error-' + (i + 1)">{{ errors.first('question'+i) }}</span>
            </div>
            <div class="form-group">
              <label class="label" :data-test-element="'security-answer-label-' + (i + 1)">{{ $t('identityProvider:securityQuestions:answer') }}</label>
              <input type="password" :name="model.isSecureNowEnabled ? ('snanswer'+i) : ('answer'+i)" class="control" v-model="model.questions[i].answer" v-validate="{ required: true, regex: model.answerComplexity.answerPattern, min: model.answerComplexity.answerMinimumLength, max: model.answerComplexity.answerMaximumLength }" :data-vv-as="$t('identityProvider:securityQuestions:answer')" v-bind:class="{ 'input-validation-error': model.isSecureNowEnabled ? hasErrorOn('snanswer'+i) : hasErrorOn('answer'+i) }" autocomplete="off" :data-test-element="'security-answer-' + (i + 1)" />
              <span class="field-validation-error" v-show="model.isSecureNowEnabled ? hasErrorOn('snanswer'+i) : hasErrorOn('answer'+i)" :data-test-element="'security-answer-error-' + (i + 1)">{{ model.isSecureNowEnabled ? errors.first('snanswer'+i) : errors.first('answer'+i) }}</span>
            </div>
          </div>
          <div class="form-actions">
            <button type="submit" name="Action:SubmitQuestions" class="button" :disabled="disabled" :data-test-element="'security-question-submit'">{{ $t('shared:action:continue') }}</button>
            <a @click.prevent="loginCancel" class="button-secondary link-text-transform" :data-test-element="'security-question-cancel'">{{ $t('shared:action:cancel') }}</a>
          </div>
        </fieldset>
      </form>
    </div>
  </div>

</template>

<script>
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import Vue from 'vue';
  import ContextualHelp from 'components/popper-help';
  import $ from 'jquery';

  Vue.component('contextual-help-component', ContextualHelp);

  export default {
    mixins: [
      validation
    ],

    data: () => ({
      model: {
        availableQuestions: null,
        instructions: null,
        questions: null
      },
      disabled: false,
      contentClass: 'content-area__content'
    }),

    methods: {
      changeQuestion(event) {
        let question = event.target;
        let selectedValue = question.value;
        var oldValue = $(question).attr('old-value');
        // For each security question input (other than the one that changed)...
        $('select.security-question', this.$refs.form).not(question).each(function () {
          if (typeof oldValue !== typeof undefined && oldValue !== false) {
            $(`option[value="${oldValue}"]`, this).each(function () {
              $(this).removeAttr('disabled');
            });
          }

          $(this).find(`option[value="${selectedValue}"]`).attr('disabled', '');

          $("select option:first-child").removeAttr("disabled");
        });

        // If user selected a non-default option, record their selection in the "old-value" data
        if (selectedValue !== '') {
          $(question).attr('old-value', selectedValue);
        }
        // User selected the default option, so remove the "old-value" data
        else {
          $(question).removeAttr('old-value');
        }
      },

      validateBeforeSubmit() {
        this.$validator.reset()
          .then(_ => {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.post();
              }
            });
          });
      },

      async post() {
        let form = this.$refs.form;
        this.disabled = true;
        try {
          let response = await this.$http.post(form.action, this.model);
          redirectHandler.checkAndRedirect(response, this.$router);
        } catch (error) {
          if (this.validateResponse(form, error.response)) {
            return;
          }
          throw error;
        } finally {
          this.disabled = false;
        }
      },

      async loginCancel() {
        let response = await this.$http.post('authentication/logincancel');
        redirectHandler.checkAndRedirect(response, this.$router);
      }
    },

    async mounted() {
      let form = this.$refs.form;
      let response = await this.$http.get(form.action);
      this.model = response.data;
      this.contentClass = response.data["showError"] ? 'w-100' : this.contentClass;
    }
  };
</script>
